<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-size-40 md-small-size-100">
        <div class="picture-container">
          <div class="picture">
            <div v-if="!image">
              <img :src="avatar" class="picture-src" title="" />
            </div>
            <div v-else>
              <img :src="image" />
            </div>
            <input id="fileInput" type="file" @change="onFileChange" style="display:none;" />
            <label for="fileInput" class="clickable-area"></label>
          </div>
          <h6 class="description">Choose Picture</h6>
        </div>
        <div align="center">
          <div style="height: 40px; display: block">
            <md-radio
              v-validate="'required'"
              v-model="radio_qualification"
              value="341"
              data-vv-name="radio_qualification"
              name="radio_qualification"
            >
              MD
            </md-radio>
            <md-radio
              v-validate="'required'"
              v-model="radio_qualification"
              value="342"
              data-vv-name="radio_qualification"
              name="radio_qualification"
            >
              OD
            </md-radio>
            <md-radio
              v-validate="'required'"
              v-model="radio_qualification"
              value="343"
              data-vv-name="radio_qualification"
              name="radio_qualification"
            >
              DO
            </md-radio>
          </div>
          <span v-if="errors.has('radio_qualification')" style="color: #f44336;font-weight: 400;" class="error-message"> Qualification is required. </span>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-65">
          <md-field
            :class="[
              { 'md-valid': !errors.has('firstName') && touched.firstName },
              'md-form-group',
              { 'md-error': errors.has('firstName') }
            ]"
          >
            <md-icon>person_outline</md-icon>
            <label>First Name</label>
            <md-input
              v-validate="modelValidations.firstName"
              v-model="firstName"
              data-vv-name="firstName"
              type="text"
              name="firstName"
              required
            />
            <slide-y-down-transition>
              <md-icon v-show="errors.has('firstName')" class="error">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon
                v-show="!errors.has('firstName') && touched.firstName"
                class="success"
              >done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </div>

        <div class="md-layout-item md-size-65">
          <md-field
            :class="[
              { 'md-valid': !errors.has('lastName') && touched.lastName },
              'md-form-group',
              { 'md-error': errors.has('lastName') }
            ]"
          >
            <md-icon>record_voice_over</md-icon>
            <label>Last Name</label>
            <md-input
              v-validate="modelValidations.lastName"
              v-model="lastName"
              data-vv-name="lastName"
              type="text"
              name="lastName"
              required
            />
            <slide-y-down-transition>
              <md-icon v-show="errors.has('lastName')" class="error">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon
                v-show="!errors.has('lastName') && touched.lastName"
                class="success"
              >done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </div>

        <div class="md-layout-item md-size-100">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-65">
              <md-field
                :class="[
                  { 'md-valid': !errors.has('cellPhone') && touched.cellPhone },
                  'md-form-group',
                  { 'md-error': errors.has('cellPhone') }
                ]"
              >
                <md-icon>smartphone</md-icon>
                <label>Cell Phone</label>
                <md-input
                  v-mask="'(999) 999 - 9999'"
                  v-validate="modelValidations.cellPhone"
                  v-model="cellPhone"
                  data-vv-name="cellPhone"
                  type="tel"
                  name="cellPhone"
                  required
                />
                <slide-y-down-transition>
                  <md-icon v-show="errors.has('cellPhone')" class="error">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon v-show="!errors.has('cellPhone') && touched.cellPhone" class="success">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>
            <div class="md-layout-item md-size-35" style="display:flex; align-items:center;">
              <md-switch v-model="allowSMS">
                <span class="lbl1">Allow SMS</span>
              </md-switch>
            </div>
          </div>
        </div>
      </div>

      <!-- MAILING ADDRESS -->
      <div class="md-layout-item md-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('address') && touched.address1 },
            { 'md-form-group': true },
            { 'md-error': errors.has('address') }
          ]"
        >
          <md-icon>location_on</md-icon>
          <label>Address</label>
          <md-input v-validate="'required'" v-model="address" data-vv-name="address" type="text" name="address" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('address')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('address') && touched.address1" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('city') && touched.city },
            { 'md-form-group': false },
            { 'md-error': errors.has('city') }
          ]"
        >
          <md-icon>location_city</md-icon>
          <label>City</label>
          <md-input v-validate="'required'" v-model="city" data-vv-name="city" type="text" name="city" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('city')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('city') && touched.state" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div
        :class="[
          { 'md-layout-item': true },
          { 'space-right-phone': true },
          { 'md-size-40': isPhone },
          { 'md-size-30': !isPhone }
        ]"
        class="md-layout-item md-size-50 md-small-size-100"
        @click="focus('state')"
      >
        <md-field
          :class="[
            { 'md-valid': !errors.has('state') && touched.state },
            { 'md-form-group': true },
            { 'md-error': errors.has('state') }
          ]"
        >
          <md-icon>outlined_flag</md-icon>
          <label>State</label>
          <md-select
            v-validate="'required'"
            id="state-select"
            ref="stateInput"
            v-model="state"
            style="margin-left: 20px"
            data-vv-name="state"
            type="text"
            name="state"
            md-dense
            @keydown.native="stateFind($event)"
          >
            <md-option
              v-for="state in states"
              :key="state.LookupId"
              :value="state.LookupId"
            >
              {{ state.DisplayValue }}
            </md-option>
          </md-select>
          <slide-y-down-transition>
            <md-icon v-show="errors.has('state')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('state') && touched.state" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('zipCode') && touched.zipCode },
            { 'md-form-group': false },
            { 'md-error': errors.has('zipCode') }
          ]"
        >
          <md-icon>location_on</md-icon>
          <label class="spaced-phone-label">Zip-Code</label>
          <md-input
            v-validate="'required'"
            ref="zipCodeInput"
            v-model="zipCode"
            data-vv-name="zipCode"
            type="text"
            name="zipCode"
          />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('zipCode')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('zipCode') && touched.zipCode" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100" @click="focus('country')">
        <md-field
          :class="[
            { 'md-valid': !errors.has('country') && touched.country },
            { 'md-form-group': false },
            { 'md-error': errors.has('country') }
          ]"
        >
          <md-icon>outlined_flag</md-icon>
          <label>Country</label>
          <md-select
            v-validate="'required'"
            id="country-select"
            ref="countryInput"
            v-model="country"
            data-vv-name="country"
            type="text"
            name="country"
            md-dense
          >
            <md-option
              v-for="country in countries"
              :key="country.LookupId"
              :value="country.LookupId"
            >
              {{ country.DisplayValue }}
            </md-option>
          </md-select>
          <slide-y-down-transition>
            <md-icon v-show="errors.has('country')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('country') && touched.country" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-100 ml-auto mt-4 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('email') && touched.email },
            { 'md-form-group': true },
            { 'md-error': errors.has('email') }
          ]"
          @keyup.enter="signIn()"
        >
          <md-icon>email</md-icon>

          <label>Email</label>
          <md-input
            v-validate="modelValidations.email"
            v-model="email"
            data-vv-name="email"
            type="email"
            name="email"
            required
          />

          <slide-y-down-transition>
            <md-icon v-show="errors.has('email')" class="error">close</md-icon>
          </slide-y-down-transition>

          <slide-y-down-transition>
            <md-icon v-show="!errors.has('email') && touched.email" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>
  </div>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions"
import { mapGetters, mapActions } from "vuex"
import $ from "jquery"

export default {
  name: "DoctorPersonalInfo",
  components: {
    SlideYDownTransition
  },
  props: {
    avatar: {
      type: String,
      default: "/img/doctor-avatar3.png"
    },
  },
  data() {
    return {
      image: "",
      single: null,
      countries: [],
      states: [],
      touched: {
        firstName: false,
        lastName: false,
        cellPhone: false,
        email: false,
        address: false,
        city: false,
        state: false,
        zipCode: false,
        country: false
      },
      modelValidations: {
        firstName: {
          required: true,
          min: 2
        },
        lastName: {
          required: true,
          min: 2
        },
        cellPhone: {
          required: true,
          min: 10
        },
        email: {
          required: true,
          email: true
        },
        radio_qualification: {
          required: true
        }
      }
    }
  },
  computed: {
    ...mapGetters('doctorProfile', ['personal', 'credentials']),
    ...mapGetters(['isPhone']),
    firstName: {
      get() {
        return this.personal.firstName || ''
      },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PERSONAL_INFO', { firstName: value })
        this.touched.firstName = false
      }
    },

    lastName: {
      get() {
        return this.personal.lastName || ''
      },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PERSONAL_INFO', { lastName: value })
        this.touched.lastName = false
      }
    },

    email: {
      get() {
        return this.personal.emailAddress || ''
      },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PERSONAL_INFO', { emailAddress: value })
        this.touched.email = false
      }
    },

    cellPhone: {
      get() {
        return this.personal.cellNumber || ''
      },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PERSONAL_INFO', { cellNumber: value })
        this.touched.cellPhone = false
      }
    },

    allowSMS: {
      get() {
        return this.personal.allowSMS || false
      },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PERSONAL_INFO', { allowSMS: value })
      }
    },

    isReader: {
      get() {
        return this.personal.isReader || false
      },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PERSONAL_INFO', { isReader: value })
      }
    },

    radio_qualification: {
      get() {
        return (this.credentials.qualification && this.credentials.qualification.toString()) || ''
      },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_CREDENTIALS', { qualification: Number(value) })
      }
    },

    address: {
      get() {
        return this.personal.address1 || ''
      },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PERSONAL_INFO', { address1: value })
        this.touched.address = false
      }
    },

    city: {
      get() {
        return this.personal.city || ''
      },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PERSONAL_INFO', { city: value })
        this.touched.city = false
      }
    },

    state: {
      get() {
        return this.personal.state || ''
      },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PERSONAL_INFO', { state: value })
        this.touched.state = false
      }
    },

    zipCode: {
      get() {
        return this.personal.zipCode || ''
      },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PERSONAL_INFO', { zipCode: value })
        this.touched.zipCode = false
      }
    },

    country: {
      get() {
        return this.personal.country || ''
      },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PERSONAL_INFO', { country: value })
        this.touched.country = false
      }
    }

  },
  watch: {
    firstName() {
      this.touched.firstName = true
    },
    lastName() {
      this.touched.lastName = true
    },
    email() {
      this.touched.email = true
    },
    state() {
      this.touched.state = true
    },
    country() {
      this.touched.country = true
    },
    address() {
      this.touched.address = true
    },
    zipCode() {
      this.touched.zipCode = true
    },
    cellPhone() {
      this.touched.cellPhone = true
    },
    city() {
      this.touched.city = true
    },
  },
  mounted() {
    this.defineLookups();
  },
  methods: {
    ...mapActions('doctorProfile', ['fetchDoctorProfile']),
    ...mapActions(["listLookupsByMasterName"]),
    stateFind(event) {
      if (event.key === "Escape") {
        this.stateFilterKeys = ""
      }
      if (event.key === "Enter") {
        this.reRenderState()
        this.$refs.zipCodeInput.$el.focus()
      }
      if (event.key.length > 1) return
      if (this.stateFilterKeys.length < 2) {
        this.stateFilterKeys += event.key.toUpperCase()
      } else {
        this.stateFilterKeys = event.key.toUpperCase()
      }
      let foundState = this.states.find((state) => {
        return state.startsWith(this.stateFilterKeys)
      })
      if (!foundState) {
        this.stateFilterKeys = ""
        return
      }
      this.state = foundState
      let value = this.states.indexOf(foundState) * 43
      let stateID = $("#" + foundState + "-state")
      let scrollParent = $(stateID).parent().parent()
      $(scrollParent).scrollTop(value)
    },
    focus(type) {
      let el = $("#" + type + "-select")
      el.focus()
    },
    fetchLookupByName(name) {
      return this.listLookupsByMasterName(name)
    },
    async defineLookups() {
      try {
        this.states = await this.fetchLookupByName("States");
        this.countries = await this.fetchLookupByName("CountryCodes");

        const usaCountry = this.countries.find(
          country => country.DisplayValue === "United States of America"
        );

        if (usaCountry && !this.personal.country) {
          this.country = usaCountry.LookupId;
        }

        await this.fillFormData();
      } catch (error) {
        console.error(error);
      }
    },
    fillFormData() {
      this.firstName = this.personal.firstName || ""
      this.lastName = this.personal.lastName || ""
      this.email = this.personal.emailAddress || ""
      this.cellPhone = this.personal.cellNumber || ""
      this.allowSMS = this.personal.allowSMS || false
      this.isReader = this.personal.isReader || false
      this.radio_qualification = (this.credentials.qualification && this.credentials.qualification.toString()) || ""
      this.address = this.personal.address1 || ""
      this.city = this.personal.city || ""
      this.state = this.personal.state || "";
      this.country = this.personal.country || "";
      this.zipCode = this.personal.zipCode || ""
    },
    handlePreview(file) {
      this.model.imageUrl = URL.createObjectURL(file.raw)
    },
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit("on-validated", res)
        return res
      })
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.createImage(files[0])
    },
    createImage(file) {
      var reader = new FileReader()
      var vm = this

      reader.onload = (e) => {
        vm.image = e.target.result
      }
      reader.readAsDataURL(file)
    },
  }
}
</script>
<style>
.lbl1 {
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.6);
}

.picture-container{
  position: relative;
  cursor: pointer;
  text-align: center;

  .description{
    margin: 0;
    margin-bottom: .5rem;
  }
}

.picture{
  width: 106px;
  height: 106px;
  background-color: #999999;
  border: 4px solid #CCCCCC;
  color: #FFFFFF;
  border-radius: 50%;
  margin: 5px auto;
  overflow: hidden;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;

  &:hover{
    border-color: #2ca8ff;
  }
}

.description{
  color: #999999;
  font-size: 14px;
}

.picture-src{
  width: 100%;
}
.clickable-area {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  z-index: 2;
}

</style>
